import { ITuple3 } from '../component-data-structure';
import { ITransitionCallback, Transition } from './transition';

export class TransitionManager<T extends number | ITuple3> {
    private _transitions: Transition<T>[]
    private _onStartAll?: ITransitionCallback<number>;
    private _onFinishAll?: ITransitionCallback<number>;
    private _completedTransitions: number;
    private _startedTransitions: number;

    constructor(...args: Transition<T>[]) {
        this._transitions = [];
        //this._transitions = args;
        this._completedTransitions = 0;
        this._startedTransitions = 0;
    }

    add(...args: Transition<T>[]): void {
        this._transitions.push(...args)
    }

    resetManager(): void {
        this._completedTransitions = 0;
        this._startedTransitions = 0;
    }

    startAll(): void {
        for (let i = 0; i < this._transitions.length; i++) {
            // console.log('run start all', this._transitions);
            this._transitions[i].start(); 
        }
    }

    get numberTransitions(): number {
        return this._transitions.length
    }

    onStartAll(onStartAll?: () => any): void {
        if (!onStartAll) return;
        this._onStartAll = onStartAll;
        this._completedTransitions = 0;
        this._startedTransitions = 0;
        const onStart = () => {
            this._startedTransitions = this._startedTransitions + 1;
            if (this._startedTransitions === this._transitions.length)  {
                // console.log('run startAll callback', this._transitions.length, this._onStartAll)
                this._onStartAll?.(this._transitions.length);
                // this._startedTransitions = 0;
                return;
            }
            // console.log('start managed transition', this._startedTransitions)
        
        }
        for (let i = 0; i < this._transitions.length; i++) {
            this._transitions[i].onStart(onStart);
        }
    }

    onFinishAll(onFinishAll?: () => any): void {
        if (!onFinishAll) return;
        this._onFinishAll = onFinishAll;
        const onFinish = () => {
            this._completedTransitions = this._completedTransitions + 1;
            if (this._completedTransitions === this._startedTransitions) {
                // console.log('run finishAll callback', this._startedTransitions, this._onFinishAll)
                this._onFinishAll?.(this._startedTransitions);
                return;
            }
            // console.log('finish managed transition', this._completedTransitions, this._startedTransitions)
        }
        // console.log('onFinish transition length before loop', this._startedTransitions);
        for (let i = 0; i < this._transitions.length; i++) {
            // console.log('onFinish transition loop', this._transitions[i].duration);
            this._transitions[i].onFinish(onFinish);
        }
    }

}